import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import TextField from "@material-ui/core/TextField";
import {getLabel} from "../../localization/MainLocalization";
import {not_validate_value} from "../../App";

let models = [
    "Users",
    "Staff",
    "Profiles",
    "Payments Methods",
    "Locations",
    "Services",
    "Price Lists",
    "Prices",
    "Offer Price Lists",
    "Offer Prices",
    // "Connect locations with services",
    "Clients",
    "Memberships",
    "Memberships Payments",
    "Class Sessions",
    "Class Session Attendances",
    "Workouts",
    "Fix Memberships Extra Days",
    "Fix Memberships Invoice ID",
    "Fix Payment Type",
];

export const ModelsAutoComplete = props => {

    return (
        <Autocomplete
            renderOption={(option) => (
                <span className="w-100 text-start">{option}</span>
            )}
            options={models}
            getOptionLabel={option => option}
            value={not_validate_value.includes(props.value)? null: props.value + ""}
            renderInput={params => (
                <TextField variant="outlined" {...params}
                           label={<label>{getLabel(props.label)}<span
                               className='text-danger'>{props.required ? "*" : ""}</span></label>}
                           helperText={props.helper_text}
                           error={props.error}
                           fullWidth
                />
            )}
            onChange={(event, value) => {
                value = value !== null ? value : "";
                props.onChangeHandle(props.name, value)
            }}
        />
    );
};
